const StatusCapsule = ({ type = "info", children }) => {
  const typeStyles = {
    success: "bg-green-100 text-green-800 border-green-300",
    error: "bg-red-100 text-red-800 border-red-300",
    warning: "bg-yellow-100 text-yellow-800 border-yellow-300",
    info: "bg-blue-100 text-blue-800 border-blue-300",
  };

  return (
    <div
      className={`px-2 py-1 rounded-full text-xs font-medium border inline-flex items-center gap-1 ${typeStyles[type]}`}
    >
      <span className="w-2 h-2 rounded-full bg-current text-xs"></span>
      {children}
    </div>
  );
};

export default StatusCapsule;
